/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useSnackbar } from "notistack";

//MATERIAL
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

import styles from "./pedidosya.module.css";

//IMPORTS
import { Notification } from "../../../containers/notification";
import { selectUser } from "../../../reducers/userSlice";
import {
  loadingOff,
  loadingOn,
  selectCompanyId,
  selectLoadingUI,
} from "../../../reducers/uiSlice";
import {
  createShipping,
  getAllShipping,
  removeShipping,
  selectShipping,
  updateShipping,
} from "../../../reducers/shippingSlice";
import shippingConstants from "../../../constants/shipping.constants";
import { selectCompany } from "../../../reducers/companySlice";
import { SelectComponent } from "../../inputs";
import {
  getPedidosyaToken,
  setPedidosyaToken,
} from "../../../utils/services/shipping";
import { useNavigate } from "react-router-dom";
import { selectSubsidiaries } from "../../../reducers/subsidiarySlice";
import { Alert } from "@material-ui/lab";
import ScrollBar from "../../scrollBar";
import {
  CheckCircleGreenIcon,
  CloseCircleGrayIcon,
  TurnWhiteIcon,
} from "../../../assets/icons/svgIcons";
import ChangeLogs from "../../changeLogs/changeLogs";
import {
  selectChangesDeposit,
  setChanges,
} from "../../../reducers/depositSlice";
import useChangeRecord from "../../../utils/hooks/useChangeRecord";

function PedidosYaComponent() {
  const logo = "https://dgdvd9d8e5bk8.cloudfront.net/peyaFullLogo.svg";
  const companyId = useSelector(selectCompanyId);
  const shippingPolicies = useSelector(selectShipping);
  const loading = useSelector(selectLoadingUI);
  const [active, setActive] = useState(false);
  const [exists, setExists] = useState(false);
  const price = 3490;
  const price2 = 3590;
  const price3 = 4000;
  const [id, setId] = useState("");
  const [deliveryTime, setDeliveryTime] = useState(30);
  const [requested, setRequested] = useState(false);
  const [isTest, setIsTest] = useState(false);
  const [financing, setFinancing] = useState(false);
  const [financingType, setFinancingType] = useState("percentage");
  const [financingValue, setFinancingValue] = useState(0);
  const [description, setDescription] = useState("");
  const [tokens, setTokens] = useState([]);
  const { recordChange } = useChangeRecord();

  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const company = useSelector(selectCompany);
  const subsidiaries = useSelector(selectSubsidiaries);
  const [subsidiaryId, setSubsidiaryId] = useState(
    subsidiaries[0]?._id ?? undefined
  );
  const navigate = useNavigate();
  const changes = useSelector(selectChangesDeposit);

  const trackFieldChange = (field, oldValue, newValue, subsidiaryId) => {
    if (oldValue === newValue) return; // no change

    const logs = [...changes];

    const existing = logs.find(
      (l) => l.field === field && l?.subsidiaryId === subsidiaryId
    );
    const selectedSubsidiary = subsidiaries?.find(
      (f) => f?._id === subsidiaryId
    );

    const newLog = {
      field,
      text: `Cambió el campo ${field} para ${selectedSubsidiary ? selectedSubsidiary?.Name : "Todas las sucursales"
        }`,
      oldValue: existing ? existing.oldValue : oldValue,
      newValue,
      date: new Date().toISOString(),
      subsidiaryId,
    };

    if (existing) {
      const index = logs.findIndex((l) => l.field === field);
      logs[index] = newLog;
    } else {
      logs.push(newLog);
    }

    dispatch(setChanges(logs));
  };

  const handleShippingSave = async () => {
    dispatch(loadingOn());
    try {
      if (id === "") {
        const shippingNew = await createShipping(
          {
            name: "PedidosYa",
            type: shippingConstants.TYPES.today.code,
            status: true,
            pickupTimeTable: [],
            useTimeWindow: false,
            useLocationVerification: false,
            shippingTimeTable: [],
            maxDistance: 0,
            price,
            price2,
            price3,
            useFulfillment: true,
            fulfillmentId: "Pedidosya",
            idCompany: companyId,
            extraInfo: {
              deliveryTime,
            },
            isTest,
            description,
            financing,
            financingType,
            financingValue,
            useSubsidiaries: true,
          },
          user.token
        );
        if (shippingNew) {
          const list = tokens.filter((t) => t?.token && t?.subsidiaryId);

          const results = await Promise.allSettled(
            list.map((data) =>
              setPedidosyaToken(
                company?._id,
                data?.token,
                data?.isTest,
                data?.subsidiaryId
              )
                .then(() => ({
                  ok: true,
                  subsidiaryId: data?.subsidiaryId,
                }))
                .catch((err) => ({
                  ok: false,
                  subsidiaryId: data?.subsidiaryId,
                  error: err,
                }))
            )
          );

          // Analizamos resultados
          const failed = results
            .filter((r) => r.status === "fulfilled" && !r.value.ok)
            .map((r) => r.value);
          /* 
      const succeeded = results
        .filter((r) => r.status === "fulfilled" && r.value.ok)
        .map((r) => r.value); */

          if (failed.length === 0) {
            enqueueSnackbar(
              Notification({
                text: "Actualizado con éxito!",
                variant: "success",
                withDetails: false,
              })
            );
          } else {
            // Obtener nombres de sucursales
            const errorsText = failed
              .map((f) => {
                const s = subsidiaries.find((s) => s._id === f.subsidiaryId);
                return `• ${s?.Name ?? "Sucursal desconocida"}: ${f.error}`;
              })
              .join("\n");

            enqueueSnackbar(
              Notification({
                text: `Algunos tokens no se pudieron actualizar:\n${errorsText}`,
                variant: "error",
                withDetails: true,
              })
            );
          }
        }
      }
    } catch (error) {
      console.log(error);
      enqueueSnackbar(
        Notification({
          text: "Ocurrió un error al intentar crear.",
          variant: "error",
          withDetails: false,
        })
      );
    } finally {
      getAllShipping(company._id, user.token, dispatch);

      dispatch(loadingOff());
    }
  };

  const handleDeleteCredentials = async () => {
    dispatch(loadingOn());
    try {
      const remove = await removeShipping(id, user.token, dispatch);
      if (remove) {
        setFinancingValue(0);
        setFinancing(false);

        setId("");
        setDescription("");
        await recordChange({
          module: "Métodos de envío",
          submodule: "PedidosYa",
          changes: [
            {
              field: "Método de envío",
              text: "Eliminación de credenciales",
              oldValue: "Credenciales registradas",
              newValue: "Credenciales eliminadas",
              date: new Date().toISOString(),
            },
          ],
        });
        enqueueSnackbar(
          Notification({
            text: "Eliminado con éxito",
            variant: "success",
            withDetails: false,
          })
        );
      }
    } catch (error) {
      enqueueSnackbar(
        Notification({
          text: "Error al elminar",
          variant: "error",
          withDetails: false,
        })
      );
    } finally {
      dispatch(loadingOff());
    }
  };

  const handleShippingUpdate = async (active, updateToken = false) => {
    dispatch(loadingOn());

    try {
      const shippingUpdate = await updateShipping(
        {
          _id: id,
          status: active,
          isTest,
          extraInfo: {
            deliveryTime,
          },
          financing,
          financingType,
          financingValue,
          description,
          useSubsidiaries: true,
        },
        user.token
      );

      if (!updateToken) {
        await recordChange({
          module: "Métodos de envío",
          submodule: "PedidosYa",
          changes: [
            {
              field: "Servicio de pedidosYa",
              text: "Cambio de estado de servicio",
              oldValue: !active ? "Activo" : "Inactivo",
              newValue: active ? "Activo" : "Inactivo",
              date: new Date().toISOString(),
            },
          ],
        });
      }

      if (shippingUpdate && updateToken) {
        const list = tokens.filter((t) => t?.token && t?.subsidiaryId);

        const results = await Promise.allSettled(
          list.map((data) =>
            setPedidosyaToken(
              company?._id,
              data?.token,
              data?.isTest,
              data?.subsidiaryId
            )
              .then(() => ({
                ok: true,
                subsidiaryId: data?.subsidiaryId,
              }))
              .catch((err) => ({
                ok: false,
                subsidiaryId: data?.subsidiaryId,
                error: err,
              }))
          )
        );
        await recordChange({
          module: "Métodos de envío",
          submodule: "PedidosYa",
          changes: changes,
        });
        // Analizamos resultados
        const failed = results
          .filter((r) => r.status === "fulfilled" && !r.value.ok)
          .map((r) => r.value);
        /* 
      const succeeded = results
        .filter((r) => r.status === "fulfilled" && r.value.ok)
        .map((r) => r.value); */

        if (failed.length === 0) {
          enqueueSnackbar(
            Notification({
              text: "Actualizado con éxito!",
              variant: "success",
              withDetails: false,
            })
          );
        } else {
          // Obtener nombres de sucursales
          const errorsText = failed
            .map((f) => {
              const s = subsidiaries.find((s) => s._id === f.subsidiaryId);
              return `• ${s?.Name ?? "Sucursal desconocida"}: ${f.error}`;
            })
            .join("\n");

          enqueueSnackbar(
            Notification({
              text: `Algunos tokens no se pudieron actualizar:\n${errorsText}`,
              variant: "error",
              withDetails: true,
            })
          );
        }
      }
    } catch (error) {
      console.error("error", error);
      enqueueSnackbar(
        Notification({
          text: `Error al guardar! ${error}`,
          variant: "error",
          withDetails: false,
        })
      );
    } finally {
      getAllShipping(company._id, user.token, dispatch);
      dispatch(loadingOff());
    }
  };

  const handleClose = () => {
    navigate(-1);
  };

  const handleChanges = (selectedCredential, property, value) => {
    setTokens((prev) => {
      const updated = prev.map((cred) => {
        if (cred?.subsidiaryId === selectedCredential?.subsidiaryId) {
          return {
            ...cred,
            [property]: value,
            //modified: true,
          };
        }

        return cred;
      });
      return updated;
    });
    trackFieldChange(
      property,
      selectedCredential?.[property],
      value,
      subsidiaryId
    );
  };
  const initialize = async () => {
    const credentialsList = [];

    if (shippingPolicies.length > 0) {
      const shipping = shippingPolicies.find(
        (item) => item.useFulfillment && item.fulfillmentId === "Pedidosya"
      );
      if (shipping) {
        setDeliveryTime(shipping.extraInfo.deliveryTime);
        setId(shipping._id);
        setIsTest(false);
        setActive(shipping?.status);
        setExists(true);
        setFinancing(shipping.financing);
        setFinancingType(shipping.financingType);
        setFinancingValue(shipping.financingValue);
        setDescription(shipping.description);
        dispatch(loadingOn());

        try {
          let tokens = await getPedidosyaToken(company?._id).catch((err) => {
            console.log(err);
          });
          if (tokens?.length) {
            const filteredTokens = tokens?.filter((t) => t?.subsidiaryId);
            subsidiaries?.forEach((s) => {
              const subsidiaryCredential = filteredTokens?.find(
                (c) => c?.subsidiaryId === s?._id
              );
              if (subsidiaryCredential) {
                credentialsList.push(subsidiaryCredential);
              } else {
                credentialsList.push({
                  /*   clientId: "",
                  expireIn: "", */
                  companyId: s?.CompanyId,
                  subsidiaryId: s?._id,
                  isTest: false,
                  token: "",
                  type: "pedidosya",
                  // isNew: true,
                });
              }
            });
            setTokens(credentialsList);
          }
        } catch (err) {
          console.log(err);
        } finally {
          dispatch(loadingOff());
        }
      } else {
        subsidiaries?.forEach((s) => {
          credentialsList.push({
            /*   clientId: "",
                    expireIn: "", */
            companyId: s?.CompanyId,
            subsidiaryId: s?._id,
            isTest: false,
            token: "",
            type: "pedidosya",
            // isNew: true,
          });
        });
        setTokens(credentialsList);
        setExists(false);
        setActive(false);
        setId("");
      }
    } else {
      subsidiaries?.forEach((s) => {
        credentialsList.push({
          /*   clientId: "",
                  expireIn: "", */
          companyId: s?.CompanyId,
          subsidiaryId: s?._id,
          isTest: false,
          token: "",
          type: "pedidosya",
          // isNew: true,
        });
      });
      setTokens(credentialsList);
    }
  };

  const credential = useMemo(
    () => tokens.find((c) => c.subsidiaryId === subsidiaryId),
    [tokens, subsidiaryId, company, subsidiaries]
  );



  useEffect(() => {
    if (subsidiaries && subsidiaries.length > 0 && !subsidiaryId)
      setSubsidiaryId(subsidiaries[0]._id);
  }, [subsidiaries]);

  useEffect(() => {
    if (!company?._id || !user?.token) return;

    const fetchAllShipping = async () => {
      dispatch(loadingOn());
      try {
        setRequested(true);
        await getAllShipping(company?._id, user?.token, dispatch);
      } catch (error) {
        console.error("error trying to get the shipping policies", error);
      } finally {
        dispatch(loadingOff());
      }
    };

    if (!requested) {
      fetchAllShipping();
    }
  }, [company, user, requested]);
  useEffect(() => {
    if (company) {
      initialize();
    }
  }, [shippingPolicies, company]);
  return (
    <div className={styles.parentContainer}>
      <div className={styles.arrowBackStatusContainer}>
        <button className={styles.backButton} onClick={() => handleClose()}>
          <span>
            <ArrowBackIcon />
          </span>
          Regresar
        </button>
        <div className={styles.changeLogsContainer}>
          <ChangeLogs
            {...{
              module: "Métodos de envío",
              submodule: "PedidosYa",
              subtitle: (
                <span>
                  Historial de modfificación de credenciales de{" "}
                  <strong>PedidosYa</strong>
                </span>
              ),
            }}
          />
          {!active ? (
            <div className={styles.containerLogoInactive}>
              <CloseCircleGrayIcon />
              <span>Inactivo</span>
            </div>
          ) : (
            <div
              className={styles.containerLogoActive}
              style={{ fontWeight: 700 }}
            >
              <CheckCircleGreenIcon />
              <span>Activo</span>
            </div>
          )}
        </div>
      </div>

      <div className={styles.infoContainer}>
        <div className={styles.titleLogoContainer}>
          <div className={styles.logoImageContainer}>
            <img src={logo} alt="Chilexpress" className={styles.imageElement} />
          </div>
          <div className={styles.infoItemContainer}>
            <p className={styles.infoItemTitle}>PedidosYa</p>
            <p className={styles.infoItem}>
              La activación del servicio de delivery de PedidosYa toma 60
              minutos. Tarifa de los envíos según dimensiones y coberturas.
            </p>
          </div>
        </div>
        <Alert
          severity="info"
          className={styles.alertMessageTable}
          classes={{ message: styles.alertMessageTable }}
          style={{ alignItems: "center" }}
        >
          <div className={styles.errorPOSContainer}>
            <p className={styles.errorPOSTitle}>
              Si usted desea hacer uso de la flota de PedidosYa, debe obtener
              las credenciales en su{" "}
              <a
                href="https://socios.pedidosya.cl/s/?language=es&countryIsoCode=CL&utm_source=PedidosYaSite&utm_medium=Site&utm_campaign=SSU_Site_Organic_CL"
                rel="noreferrer"
                target="_blank"
              >
                página
              </a>{" "}
              y darnos acceso a ellas para automatizar sus procesos.
            </p>
          </div>
        </Alert>

        <div className={styles.configSettingsContainer}>
          <div className={styles.inputContainer}>
            <label className={styles.labelInput}>Descripción</label>

            <input
              className={styles.inputElement}
              disabled={(!active && exists) || loading}
              placeholder="Ejemplo: Envío a domicilio en 24hrs"
              type="text"
              value={description}
              onChange={(e) => {
                setDescription(e.target.value);
                trackFieldChange("Descripción", description, e.target.value);
              }}
            />
          </div>
          <div className={styles.inputContainer}>
            <label className={styles.labelInput}>Tiempo de entrega</label>

            <input
              className={styles.inputElement}
              disabled={(!active && exists) || loading}
              placeholder="Ejemplo: 30 min"
              type="number"
              value={deliveryTime}
              onChange={(e) => {
                setDeliveryTime(e.target.value);
                trackFieldChange(
                  "Tiempo de entrega",
                  deliveryTime,
                  e.target.value
                );
              }}
            />
          </div>
          <div className={styles.inputContainerCheckbox}>
            <input
              type="checkbox"
              checked={financing}
              onChange={(e) => {
                setFinancing(e.target.checked);
                trackFieldChange(
                  "Financiamiento",
                  financing ? "Activo" : "Inactivo",
                  e.target.checked ? "Activo" : "Inactivo"
                );
              }}
              value={"financing"}
              style={{ color: "#122526" }}
              disabled={(!active && exists) || loading}
            />
            <label className={styles.labelInput}>Activar financiamiento</label>
          </div>
          {financing && (
            <div className={styles.inputContainer}>
              <label className={styles.labelInput}>
                Tipo del financiamiento
              </label>
              <SelectComponent
                value={financingType}
                handler={(value) => {
                  setFinancingType(value);
                  trackFieldChange(
                    "Tipo de financiamiento",
                    financingType,
                    value
                  );
                }}
                disabled={(!active && exists) || loading}
                array={[
                  {
                    name: "Por porcentaje",
                    value: "percentage",
                  },
                  {
                    name: "Por monto",
                    value: "amount",
                  },
                ]}
              />
            </div>
          )}

          {financing && (
            <div className={styles.inputContainer}>
              <label className={styles.labelInput}>
                Valor del financiamiento
              </label>
              <input
                disabled={(!active && exists) || loading}
                className={styles.inputElement}
                placeholder="Ejemplo: 12"
                type="text"
                value={financingValue}
                onChange={(e) => {
                  setFinancingValue(e.target.value);
                  trackFieldChange(
                    "Valor de financiamiento",
                    financingValue,
                    e.target.value
                  );
                }}
              />
            </div>
          )}
        </div>
        <div className={styles.lineDivisor}></div>

        <div className={styles.configSettingsContainer}>
          <div className={styles.infoItemContainer}>
            <p className={styles.infoItemTitle}>Credenciales</p>
            <p className={styles.infoItem}>
              Ingrese las credenciales de PedidosYa asociadas a tu sucursal
            </p>
          </div>
          {subsidiaries && (
            <ScrollBar
              value={subsidiaryId}
              onChange={(newValue) => setSubsidiaryId(newValue)}
              list={subsidiaries}
              useCustomStyles={true}
              customStyles={{
                wrapper: styles.wrapperclass,
                tabList: styles.tabListClass,
                tabItem: styles.tabItemClass,
                activeTab: styles.activeTabClass,
              }}
            />
          )}
          <div className={styles.inputContainer}>
            <label className={styles.labelInput}>Token</label>
            <input
              key={`restaurantId-${credential?.subsidiaryId}`}
              className={styles.inputElement}
              disabled={(!active && exists) || loading}
              placeholder="Ejemplo: 123456789"
              type="text"
              value={credential?.token}
              onChange={(e) => {
                handleChanges(credential, "token", e.target.value);
              }}
            />
          </div>
          <div className={styles.inputContainerCheckbox}>
            <input
              key={`restaurantId-${credential?.subsidiaryId}`}
              type="checkbox"
              disabled={(!active && exists) || loading}
              checked={credential?.isTest}
              onChange={(e) => {
                handleChanges(credential, "isTest", e.target.checked);
              }}
              value={"isTest"}
              style={{ color: "#122526" }}
            />
            <label className={styles.labelInput}>Activar modo prueba</label>
          </div>
        </div>
        <div className={styles.lineDivisor}></div>
        {id && (
          <div className={styles.statusBtnContainer}>
            <div
              className={
                active
                  ? styles.btnStatusContainerInactive
                  : styles.btnStatusContainerActive
              }
            >
              <button
                className={
                  active ? styles.statusInactiveBtn : styles.statusActiveBtn
                }
                onClick={() => handleShippingUpdate(!active)}
                disabled={loading}
              >
                <TurnWhiteIcon />
              </button>
              <p className={styles.statusText}>
                {active ? "Inactivar servicio" : "Activar servicio"}
              </p>
            </div>
            {active ? (
              <p className={styles.statusShippment}>
                El servicio está{" "}
                <span style={{ color: "#008236", fontWeight: 700 }}>
                  activo
                </span>{" "}
                y procesando entregas en todas las sucursales
              </p>
            ) : (
              <p className={styles.statusShippment}>
                El servicio está{" "}
                <span style={{ color: "#E7000B", fontWeight: 700 }}>
                  inactivo
                </span>{" "}
                y las entregas estan suspendidas en todas las sucursales
              </p>
            )}
          </div>
        )}
        <div className={styles.btnsContainerWithValidation}>
          <div className={styles.buttonsContainer}>
            {id && (
              <button
                onClick={() => {
                  handleDeleteCredentials();
                }}
                disabled={loading}
                className={styles.deleteButton}
              >
                Eliminar credenciales
              </button>
            )}
            {active && (
              <button
                className={styles.confirmButton}
                onClick={() => handleShippingUpdate(active, true)}
                disabled={loading}
              >
                Actualizar credenciales
              </button>
            )}

            {id === "" && price !== 0 && price2 !== 0 && price3 !== 0 && (
              <button
                className={styles.confirmButton}
                onClick={() => handleShippingSave()}
                disabled={loading}
              >
                Crear credenciales
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PedidosYaComponent;
